/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SportDefinitionResume { 
    /**
     * Localized sport name (resolved to requested lang)
     */
    name: string;
    _id: string;
    id: string;
    icon: string;
    image: string;
    tags: Array<string>;
    maxLevel: number;
}

